import React from "react";
import Card from "../../share/cards/Card";
import AdminPagination from "../../share/Pageination/AdminPagination";

function MyTeamTable(props) {
  return (
    <div className="mx-24 py-24">
      <Card className="SupportTicketTable-card SupportTicketTable-header ">
        {props.header.map((item, id) => (
          <div>{item.title}</div>
        ))}
      </Card>
      {props.list.map((i, id) => (
        <Card
          key={i?.id}
          className="SupportTicketTable-card SupportTicketTable-body  my-4"
        >
          <div
            className=" cursor-pointer"
            onClick={() => props.showModal(true)}
          >
            {i?.name}
          </div>
          <div>{i?.date}</div>

          <div>{i?.test}</div>

          <div>
            <p>{i.btn}</p>
          </div>
        </Card>
      ))}
      <AdminPagination pageSize={10} className=" mt-[3rem]" />
      {props.children}
    </div>
  );
}

export default MyTeamTable;
